import { render, staticRenderFns } from "./PrerequisiteMenu.vue?vue&type=template&id=52ee9a23&scoped=true&"
import script from "./PrerequisiteMenu.vue?vue&type=script&lang=ts&"
export * from "./PrerequisiteMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PrerequisiteMenu.vue?vue&type=style&index=0&id=52ee9a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee9a23",
  null
  
)

export default component.exports